import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";

const ContactModal = () => {
  const { user } = useSelector((state) => state.user);
  
  const initialContactData = useMemo(() => ({
    email: user?.data?.email || "",
    telephone: user?.data?.telephone || "",
  }), [user?.data?.email, user?.data?.telephone]);

  const [contactData, setContactData] = useState(initialContactData);

  useEffect(() => {
    setContactData(initialContactData);
  }, [initialContactData]);

  const handleEmailChange = useCallback((e) => {
    setContactData((prev) => ({
      ...prev,
      email: e.target.value,
    }));
  }, []);

  const handleTelephoneChange = useCallback((e) => {
    setContactData((prev) => ({
      ...prev,
      telephone: e.target.value,
    }));
  }, []);

  const handleKeyPress = useCallback((e) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  }, []);

  return (
    <div className="form-row flex flex-col sm:flex-row gap-4">
      <div className="form-group w-full sm:w-1/2">
        <label htmlFor="email" className="label-edit">
          Mail Adresi
        </label>
        <input
          className="custom-input w-full px-4"
          placeholder="Mail adresi giriniz"
          id="email"
          name="email"
          type="email"
          value={contactData.email}
          onChange={handleEmailChange}
        />
      </div>
      <div className="form-group w-full sm:w-1/2">
        <label htmlFor="telephone" className="label-edit">
          Telefon Numarası
        </label>
        <input
          className="custom-input w-full px-4"
          placeholder="Telefon numarası giriniz"
          id="telephone"
          name="telephone"
          type="tel"
          pattern="[0-9]*"
          onKeyPress={handleKeyPress}
          value={contactData.telephone}
          onChange={handleTelephoneChange}
        />
      </div>
    </div>
  );
};

export default React.memo(ContactModal);
